import { Fetch } from 'lib';
import type { PageCategoryProductsSettings } from 'types';

type RequestResponses = {
  pageSettings: PageCategoryProductsSettings;
};

const getPageCategoryProducts = async () =>
  await Fetch<RequestResponses>({
    url: 'adminPageBuilder/getPageCategoryProducts',
  });

export { getPageCategoryProducts };
